import React from 'react'
import FlexView from 'react-flexview'


const Footer = (props)=>(
    <FlexView hAlignContent="center" vAlignContent="end" style={{margin:"20px 0"}}>
        Copyright &copy; 2019 livoniatech.com
    </FlexView>
)


export default Footer
